import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {},
    descClass: {
      ...theme.fonts.p2,
      textAlign: "left",
      marginTop: 32,
    },
    infoClass: {
      ...theme.fonts.caption,
      marginTop: 8,
      color: theme.colors.textSubtle,
      textAlign: "left",
    },
    textfield: {
      paddingTop: 32,
      "& > *": {
        textAlign: "left",
      },
    },
    verifyButton: {
      marginTop: 32,
      width: "100%",
    },
    linkButton: {
      paddingLeft: 0,
      marginTop: 32,
      float: "left",
    },
    disabledTextField: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      textAlignLast: "center",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
